export default {
  newMortgage: {
    cta: "Next",
    step_1: {
      title: "Will you live there, or is it an investment property?",
      subtitle: "Lenders often offer discounts for owner-occupied properties",
      option_1: "I will live there",
      option_2: "It's an investment"
    },
    step_2: {
      title: "Which of the following is most important to you?",
      option_1: "Find out how much I can borrow",
      option_2: "Compare rates",
      option_3: "Get advice on my mortgage options",
      option_4: "Get the best mortgage as soon as possible"
    },
    step_3: {
      title: "How much money do you plan on spending on a property?"
    },
    step_4: {
      title: "How close are you from buying?",
      option_1: "I signed an offer to buy",
      option_2: "I found the perfect property",
      option_3: "I am actively looking",
      option_4: "I am not looking yet"
    },
    step_5: {
      title: "Lastly, where should we send your mortgage rates?",
      placeholder_name: "Fullname",
      placeholder_email: "Email",
      placeholder_areacode: "Area Code",
      placeholder_number: "Phone Number",
      cta: "SHOW ME RATES",
      consultedAlreadyYes: "Yes",
      consultedAlreadyNo: "No",
      consultedType1: "Other Reverse Mortgage Lender",
      consultedType2: "Family",
      consultedType3: "Wealth Manager",
      consultedType4: "Bank Branch",
      consultedType5: "Broker",
      consultedType6: "Other",
      placeholder_consultedTypeOther: "Specify"
    },
    policy:
      "By continuing, you agree to our <a href='/terms-of-service'>Terms of Service</a> and <a href='/privacy-policy'>Privacy Policy</a>.",
    loaderText: "Selecting the best rates from 2,026 products...",
    calculator: {
      cta: "CONTINUE"
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/translations/en/new-mortgage.js